import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import OuterShadow from './OuterShadow';

var Shadow = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(Shadow, _React$PureComponent);

  var _super = _createSuper(Shadow);

  function Shadow() {
    _classCallCheck(this, Shadow);

    return _super.apply(this, arguments);
  }

  _createClass(Shadow, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(OuterShadow, this.props);
    }
  }]);

  return Shadow;
}(React.PureComponent);

_defineProperty(Shadow, "defaultProps", {
  useArt: true,
  // 为了保证iOS和Adr的一致性，默认用Art
  shadowPosition: 'all'
});

export { Shadow as default };